<template>
	<div>
		<transition name="fade" mode="out-in">
			<router-view class="view"></router-view>
		</transition>
		<div class="online-container" @mouseover="serviceShow=true" @mouseleave="serviceShow=false">
			<div class="online-service">
				<img src="./assets/img/index/icon_footer_help.svg" alt="联系我们">
				<span>联系我们</span>
			</div>
			<div class="online-service-content" v-show="serviceShow">
				<ul>
					<li>
						<img src="./assets/img/index/icon_phone.svg" alt="咨询电话">
						<div>
							<span class="service-title">咨询电话</span>
							<span class="service-phone">400-116-0808</span>
						</div>
					</li>
					<li @click="goConsult">
						<img src="./assets/img/index/icon_customerservice.svg" alt="在线咨询">
						<div>
							<span class="service-title">在线咨询</span>
							<span>咨询享免费产品体验与专业讲解</span>
						</div>
					</li>
					<li>
						<a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=2186090024&site=qq&menu=yes">
							<img src="./assets/img/index/icon_qq.svg" alt="在线QQ">
							<div>
								<span class="service-title">在线咨询</span>
								<span>咨询享免费产品体验与专业讲解</span>
							</div>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
    export default {
        name: 'app',
        provide () {
            return {
                reload: this.reload,
                goRooter: this.goRooter,
                goSelf: this.goSelf,
                goConsult: this.goConsult
            }
        },
        data () {
            return {
                isRouterAlive: true,
                serviceShow: false,
                isShow: true
            }
        },
        created () {
        },
        components: {},
        methods: {
            reload () {
                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            },
            goRooter (value) {
                let routeUrl = this.$router.resolve({ path: value })
                window.open(routeUrl.href, '_blank')
            },
            goSelf (value) {
                if (value) {
                    let routeUrl = this.$router.resolve({ path: value })
                    let result = ''
                    if (value === '/index') {
                        result = this.$global.frontPath
                    } else {
                        result = this.$global.frontPath + routeUrl.href
                    }
                    return result
                } else {
                    return 'javascript:void(0);'
                }
                //        this.reload()
            },
            // 咨询
            goConsult () {
                if (this.$func.getCurrentBrowser() === ('IE10' || 'IE9' || 'IE')) {
                    window.open('http://p.qiao.baidu.com/cps/chat?siteId=12141494&userId=25576210', '_blank')
                } else {
                    window.open('http://p.qiao.baidu.com/cps/chat?siteId=12141494&userId=25576210', '_blank')
                }
            },
            serviceEnter (bool) {
                this.serviceShow = true
            },
            serviceOut (bool) {
                this.serviceShow = false
            }
        }
    }
</script>

<style lang="scss">
	.online-service {
		position: absolute;
		bottom: 165px;
		right: 0;
		padding: 8px 14px;
		width: 44px;
		height: 105px;
		background: #FFFFFF;
		border: 1px solid #E4E9F1;
		box-shadow: 0 2px 4px 0 rgba(3, 27, 78, 0.06);
		border-radius: 3px;


		img {
			margin-bottom: 8px;
			width: 13.5px;
			height: 13.5px;
			color: #29BECE;
		}

		span {
			font-size: 12px;
			color: #333333;
			letter-spacing: 0;
			line-height: 15px;
		}
	}

	.online-service-content {
		position: absolute;
		bottom: 60px;
		left: calc(100% - 378px);
		padding: 24px 22px;
		z-index: 999;
		width: 323px;
		height: 210px;
		border: 1px solid #E4E9F1;
		border-radius: 3px;
		background: #FFFFFF;
		box-shadow: 0 4px 10px 0 rgba(3, 27, 78, 0.10);

		li {
			margin-top: 24px;
			display: flex;
			align-items: center;

			div {
				margin-left: 13px;
				display: flex;
				flex-direction: column;
			}

			img {
				width: 23px;
				height: 23px;
			}

			span {
				display: inline-block;
				font-size: 12px;
				color: #929AA9;
				letter-spacing: 0;
			}

			.service-title {
				margin-bottom: 2px;
				font-size: 14px;
				color: #10263D;
				letter-spacing: 0;
			}

			.service-phone {
				color: #29BECE;
				font-size: 14px;
			}
		}

		li:first-child {
			margin-top: 0;
		}

		li > a {
			display: flex;
			align-items: center;
		}
	}
</style>

<style>
	.online-container{
		width:44px;
		position: fixed;
		bottom: 60px;
		right: 4px;
		z-index: 999;
	}

	.online-container:hover{
		width:372px;
		height:243px;
	}

</style>



// WEBPACK FOOTER //
// App.vue?5c4c1495